import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';
import { DISPLAY_TIME_ZONE, formatInDisplayZone } from './format-date';

/**
 * Часы и минуты считаем в DISPLAY_TIME_ZONE, чтобы период в фильтре совпадал с таблицей.
 * Возвращаемая `date` — «сдвинутая»: её локальные поля равны настенному времени в этой зоне
 * (так с ней работает календарь).
 */
export const localParts = (iso: string): { date: Date | undefined; time: string } => {
  if (!iso) return { date: undefined, time: '' };
  const instant = new Date(iso);
  if (Number.isNaN(instant.getTime())) return { date: undefined, time: '' };
  return {
    date: utcToZonedTime(instant, DISPLAY_TIME_ZONE),
    time: formatInDisplayZone(instant, 'HH:mm'),
  };
};

export const formatPeriodEdge = (iso: string): string => {
  const instant = new Date(iso);
  return Number.isNaN(instant.getTime()) ? iso : formatInDisplayZone(instant, 'dd.MM.yyyy HH:mm');
};

export const combineLocalDateTime = (date: Date, time: string, end = false): string => {
  const next = new Date(date);
  const match = /^(\d{2}):(\d{2})$/.exec(time);
  if (match) {
    next.setHours(Number(match[1]), Number(match[2]), end ? 59 : 0, 0);
  } else {
    next.setHours(end ? 23 : 0, end ? 59 : 0, end ? 59 : 0, 0);
  }
  return zonedTimeToUtc(next, DISPLAY_TIME_ZONE).toISOString();
};
